/**
 * Per-key merge of `source` into an Immer draft `target` map.
 *
 * Prefer this over `target = { ...target, ...source }` inside reducers — the
 * spread allocates a throwaway wrapper that Immer immediately discards while
 * building the next state.
 */
export const mergeIntoMap = <V>(target: Record<string, V>, source: Record<string, V> | undefined | null): void => {
    if (!source) return;
    for (const [k, v] of Object.entries(source)) {
        target[k] = v;
    }
};
